'use strict';

angular.module('substoreApp.services')
    .service('emailValidationService', function () {
        // CAP-1843: valid email regex:
        // * allow exactly one '@' in the middle
        // * don't allow any whitespace
        // * don't allow '<' and '>' because of CSS vulnerability attacks
        // * don't allow '.' at start and end
        // * don't allow two consecutive '.'
        // * the parts before and after the '@' may not be larger than 999,
        //   thus totalling to a maximum length of 2000 chars (which is the
        //   maximum allowed lengths for SubSe's description elements)
        var emailRegex = /^[^\s@<>.]([^\s@<>.]|(\.(?!\.|@))){0,998}@[^\s@<>.]([^\s@<>.]|(\.(?!\.|$))){0,998}$/;

        function isValidEmail(s) {
            return s.match(emailRegex) != null;
        }

        return {
            isValid: isValidEmail
        }
    });